import { initialState, Actions, State, SHOW_PREVIEW_PDF, HIDE_PREVIEW_PDF } from '../types/preview-pdf'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SHOW_PREVIEW_PDF:
      return {
        visiblePreviewPdf: action.payload,
      }
    case HIDE_PREVIEW_PDF:
      return {
        visiblePreviewPdf: null,
      }
    default:
      return state
  }
}

export default reducers
